// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
};

const UpdateCard = (props: Props) => {
  const {
    visible,
    close,
    submit,
  } = props;

  const updateSelectedCard = () => {
    submit();
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={updateSelectedCard} type="danger">Update</SpButton>,
      ]}
      title="Update Default Debit Card"
    >
      <div className="px-4">
        <div className="mt-1">Are you sure you want to update the default card?</div>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default UpdateCard;
